import { Injectable } from "@angular/core";
import { Concessao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity";
import { AitTaxiController } from "app/controllers/mob/ait-taxi.controller";
import { AitTaxiDTO, AitTaxiDTOList } from "app/model/dtos/mob/ait-taxi.dto";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { AitTaxiSearch } from "./ait-taxi.search";

@Injectable({
    providedIn: "root",
})
export class AitTaxiService implements ApiService<AitTaxiDTO>{

    constructor(
        private _aitTaxiController: AitTaxiController,
        private _loaderService: LoaderService
    ) { }

    find(search?: AitTaxiSearch): Promise<AitTaxiDTO[]> {
        throw new Error("Method not implemented.");
    }

    findAits(search?: AitTaxiSearch): Promise<AitTaxiDTOList> {
        this._loaderService.show();
        return this._aitTaxiController.findAits(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    get(id: number): Promise<AitTaxiDTO> {
        this._loaderService.show();
        return this._aitTaxiController.get(id).finally(() => this._loaderService.hide());
    }

    save(entity: AitTaxiDTO): Promise<AitTaxiDTO> {
        if (!entity.cdAit)
            return this.create(entity);
        return this.update(entity);
    }

    create(entity: AitTaxiDTO): Promise<AitTaxiDTO> {
        this._loaderService.show();
        return this._aitTaxiController.create(entity).finally(() => this._loaderService.hide());
    }

    update(entity: AitTaxiDTO): Promise<AitTaxiDTO> {
        this._loaderService.show();
        return this._aitTaxiController.update(entity).finally(() => this._loaderService.hide());
    }

    findPermissionario(aitTaxiSearch?: AitTaxiSearch): Promise<Concessao> {
        this._loaderService.show();
    
        try {
          return this._aitTaxiController.findPermissionario((aitTaxiSearch && aitTaxiSearch.getFilters()) || null).finally(() => this._loaderService.hide());
        } catch (error) {
          this._loaderService.hide()
          console.log(error);
          return null;
        }
      }
}